import React, { Component, memo } from 'react';
import { AgGridReact } from 'ag-grid-react';
import EditBtnCellRenderer from './editBtnCellRenderer';
import { fetchUserInfoes } from '../../../../services/clinicPortalServices/userInfoService';
import SearchMenu from './searchMenu';
import { createAudit } from '../../../../services/clinicPortalServices/auditService';
import { auditEnums } from '../../../../services/common/constants';
import { getUserDetails } from '../../../../services/common/util';
import { ThemeContext } from '../../../../theme/ThemeProvider';
import moment from 'moment';
import { colorSchemeDark, colorSchemeLight, themeQuartz } from 'ag-grid-community';

const themeLight = themeQuartz.withPart(colorSchemeLight);
const themeDark = themeQuartz.withPart(colorSchemeDark);

class ClinicUserInfoGrid extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quickFilterText: '',
            columnDefs: [
                {
                    headerName: 'Actions',
                    minWidth: 100,
                    maxWidth: 100,
                    cellStyle: { textAlign: 'center' },
                    cellRenderer: 'editBtnCellRenderer'
                },
                {
                    headerName: 'Title',
                    minWidth: 150,
                    resizable: true,
                    field: 'title'
                },
                {
                    headerName: 'Google Drive Link',
                    minWidth: 150,
                    resizable: true,
                    field: 'google_drive_link',
                    cellRenderer: memo((params) => {
                        return params.value ? (
                            <a href={params.value} target="_blank" rel="noreferrer">
                                {params.value}
                            </a>
                        ) : (
                            ''
                        );
                    })
                },
                {
                    headerName: 'Loom Embed Code',
                    minWidth: 150,
                    resizable: true,
                    field: 'loom_embed_code'
                },
                {
                    headerName: 'Role',
                    minWidth: 150,
                    resizable: true,
                    field: 'role'
                }
            ],
            components: {
                editBtnCellRenderer: EditBtnCellRenderer
            },
            defaultColDef: {
                flex: 1,
                filter: true,
                sortable: true
            },
            rowData: [],
            context: { componentParent: this }
        };
    }

    onGridReady = (params) => {
        this.gridApi = params.api;

        this.loadGridData();
    };

    loadGridData = () => {
        fetchUserInfoes().then((response) => {
            this.setState({ rowData: response.data });
        });
    };

    onFilterTextChange = (e) => {
        this.setState({ quickFilterText: e.target.value });
    };

    clearFilter = () => {
        this.gridApi.setFilterModel(null);
        this.setState({ quickFilterText: '' });
        document.getElementById('reset-form').value = '';
    };

    onBtnExport = () => {
        this.gridApi.exportDataAsExcel({
            fileName: 'UserInfo_Grid_' + moment().format('YYYY_MM_DD_HH_mm_ss') + '.xlsx',
            sheetName: 'UserInfoes'
        });
        const userData = JSON.parse(getUserDetails());
        const auditData = {
            identifier: auditEnums.IDENTIFIERS.ExportRecord,
            event_type: auditEnums.EVENTTYPES.UserInfoManagementGridExported,
            user_id: userData._id,
            user_name: userData.user_name + ' (' + userData.role + ')',
            update_string: auditEnums.EVENTTYPES.UserInfoManagementGridExported
        };
        createAudit(auditData);
    };

    render() {
        return (
            <div className="clinic-contain">
                <SearchMenu
                    onFilterTextChange={this.onFilterTextChange}
                    clearFilter={this.clearFilter}
                    onBtnExport={this.onBtnExport}
                    context={this.state.context}
                />
                <div
                    style={{
                        width: '100%',
                        height: 'calc(100vh - 250px)',
                        padding: '15px'
                    }}
                >
                    <ThemeContext.Consumer>
                        {({ themeName }) => (
                            <div
                                id="myGrid"
                                style={{
                                    height: '100%',
                                    width: '100%'
                                }}
                            >
                                <AgGridReact
                                    columnDefs={this.state.columnDefs}
                                    defaultColDef={this.state.defaultColDef}
                                    masterDetail={true}
                                    onGridReady={this.onGridReady}
                                    rowData={this.state.rowData}
                                    pagination={true}
                                    paginationAutoPageSize={true}
                                    components={this.state.components}
                                    context={this.state.context}
                                    theme={themeName === 'Light' ? themeLight : themeDark}
                                    quickFilterText={this.state.quickFilterText}
                                />
                            </div>
                        )}
                    </ThemeContext.Consumer>
                </div>
            </div>
        );
    }
}

export default ClinicUserInfoGrid;
